import { Link } from 'react-router-dom';
import { allCategories } from '@/utils/articles';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-foreground-950 text-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-label font-bold text-lg">
                91
              </span>
              <span className="text-lg font-black text-background-50">91黑料</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              聚合最新娱乐黑料爆料与娱乐资讯，按分类组织内容，支持搜索与筛选，为娱乐八卦爱好者提供便捷的信息入口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 flex items-center gap-2">
              <a href="#footer-nav" className="hover:text-primary-400">分类导航</a>
            </h4>
            <ul className="space-y-2.5">
              {allCategories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 flex items-center gap-2">
              <a href="#footer-links" className="hover:text-primary-400">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  资讯列表
                </Link>
              </li>
              <li>
                <Link to="/star" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  明星专题
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  站内搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 flex items-center gap-2">
              <a href="#footer-contact" className="hover:text-primary-400">联系我们</a>
            </h4>
            <ul className="space-y-3 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i> contact@91heiliao.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i> 微信公众号：91黑料
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-error-warning-line text-primary-400 mt-0.5"></i>
                <span>本站内容均为虚构演示，不涉及真实隐私，请理性娱乐。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            © {year} 91黑料 · 最新娱乐黑料爆料平台 · 演示项目
          </p>
          <p className="text-xs text-background-500 flex items-center gap-4">
            <span>内容仅供娱乐参考</span>
            <span className="hidden sm:inline">·</span>
            <span>抵制谣言 理性吃瓜</span>
          </p>
        </div>
      </div>
    </footer>
  );
}